/**
 * 判断是否在服务端环境
 * @returns {boolean}
 */
const isServer = () => {
    return typeof window === 'undefined';
};

export default isServer;
